import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { SquareLoader } from 'react-spinners'; // ✅ fixed import (named export)
import MainLayout from './layout/MainLayout';
import AuthLayout from './layout/AuthLayout';
import DashboardLayout from './layout/DashboardLayout';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth } from './slices/authSlice';
import { fetchUserData, syncGuestData } from './slices/sessionSlice';
import SingleBlog from './pages/SingleBlog';

// Lazy-loaded pages
const Home = lazy(() => import('./pages/Home'));
const Shop = lazy(() => import('./pages/Shop'));
const ProductDetails = lazy(() => import('./pages/Product'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Cart = lazy(() => import('./pages/Cart'));
const Checkout = lazy(() => import('./pages/Checkout'));
const BlogsPage = lazy(() => import('./pages/BlogsPage'));
const SignIn = lazy(() => import('./pages/SignIn'));
const NotFound = lazy(() => import('./pages/PageNotFound'));

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);

  useEffect(() => {
    const checkAndSync = async () => {
      const result = await dispatch(checkAuth());
      if (result.meta.requestStatus === "fulfilled" && result.payload) {
        // ✅ Automatically sync local guest data to backend
        // await dispatch(syncGuestData({ email: result.payload }));
        // ✅ Fetch updated (merged) cart & wishlist
        await dispatch(fetchUserData(result.payload));
      }
    };
    checkAndSync();
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Suspense fallback={
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SquareLoader />
      </div>
    }>
      <Routes>

        {/* Auth Layout */}
        <Route element={<AuthLayout />}>
          <Route path="/signin" element={<SignIn />} />
        </Route>

        {/* Dashboard Layout */}
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/shop/:collection" element={<Shop />} />
          <Route path="/product/:sku" element={<ProductDetails />} />
        </Route>

        {/* Main Layout */}
        <Route element={<MainLayout />}>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:id" element={<SingleBlog />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="*" element={<NotFound />} />
        </Route>

      </Routes>
    </Suspense>
  );
}

export default App;
